export default "/images/vendor/flag-icons/flags/1x1/es-pv.svg?e0f6252aacba9bacf0beffb9995375b2";